import { useEffect, useState } from "react";
import IMG from "../../assets/images/Download.jpeg";

export default function ScheduleTable() {
  const [schedule, setSchedule] = useState([]);
  useEffect(function () {
    async function fetchSchedule() {
      const response = await fetch("data/kiyg25-schedule.json");
      const data = await response.json();
      setSchedule(data);
      console.log("Schedule", data);
    }
    fetchSchedule();
  }, []);
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            {/* <th style={{ textAlign: "center" }}>S. No.</th> */}
            <th style={{ textAlign: "center" }}>Game</th>
            <th style={{ textAlign: "center" }}>Dates</th>
            <th style={{ textAlign: "center" }}>Venue</th>
            <th style={{ textAlign: "center" }}>Place</th>
            <th style={{ textAlign: "center" }}>Schedule</th>
          </tr>
        </thead>
        <tbody>
          {schedule?.map(function (item, index) {
            return (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#bfb" : "#fdd",
                  fontWeight: "bold",
                }}
              >
                {/* <td>{index + 1}</td> */}
                <td>
                  {!!item?.game?.schedule ? (
                    <a
                      href={item?.game?.schedule}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "underline", color: "blue" }}
                    >
                      {item?.game?.en}
                    </a>
                  ) : (
                    item?.game?.en
                  )}
                </td>
                <td>
                  {`${item?.start}`?.padStart(2, "0")} May 2025 -{" "}
                  {`${item?.end}`?.padStart(2, "0")} May 2025
                </td>
                <td>{item?.venue?.en}</td>
                <td>{item?.place?.en}</td>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {!!item?.scheduleLink ? (
                    <a href={item?.scheduleLink ?? "#"} target="_blank" rel="noreferrer">
                      <img
                        src={IMG}
                        alt="Download"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    "---"
                  )}
                </td>
              </tr>
            );
          })}
          {/* Add more rows as needed */}
        </tbody>
      </table>
    </div>
  );
}
